import constants from "../../constants/constants";
import React, { useEffect, useState } from 'react'
import { ToPersianNumber, CommaSeparator, DateToPersianNumber } from "../../functions";
import { Note, UnCheck, Check } from "../../assets/images/svg/icon";
import { List } from "@material-ui/core";


const RejectedInvoice = ({
    item,
    data,
    setData,
    showModalCountRejected,
    setShow,
    setContent,
    setSelectedForCheckAgain,
    setTitle,
    setviewDetail,
    addToCheckedList,
    removeFromCheckedList,
    checkedList,
    setCheckedList

}) => {


    //*************************************************************************** */
    const [checked, setChecked] = useState(false);
    //***************************************************************************** */
    const viewFactorFn = (e) => {
        setShow(true)
        let tempContent = item?.Description + '-' + item?.CreatorNameAndFamily + '\n \n(' + DateToPersianNumber(item?.PersianOfficialFactorChangeDate) + ')'
        setContent(tempContent)
        setTitle(constants.RejectInvoiceReason)
        setviewDetail(true)
    }
    //***************************************************************************** */
    return (
        <div className='d-flex flex-row justify-content-center ' >
            <span className="pdf-icon-invoice" onClick={(e) => { viewFactorFn(e) }}><Note /></span>
            {checkedList.some(i => i === item.OfficialFactorId) && <span onClick={(e) => {
                let temp = [...checkedList]
                temp = temp.filter(i => i !== item.OfficialFactorId)
                setCheckedList(temp)
            }}>  <Check /></span>}
            {!checkedList.some(i => i === item.OfficialFactorId) && <span onClick={(e) => {
                let temp = [...checkedList]
                temp.push(item.OfficialFactorId)
                setCheckedList(temp)
            }}>  <UnCheck /></span>}
        </div>
    )
}

export default RejectedInvoice